import React from "react";
import { PcpConfirmDialog } from "./PcpConfirmDialog";


interface ConfirmRemoveParticipantDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmRemoveParticipantDialog = (props: ConfirmRemoveParticipantDialogProps): JSX.Element => (
    <PcpConfirmDialog
        title={'Schüler entfernen'}
        content={'Möchten Sie den Schüler wirklich aus dem Unterricht entfernen?'}
        onClose={props.onClose}
        open={props.open}
        onConfirm={props.onConfirm}
        cancelText={'Nein'}
        confirmText={'Ja, Schüler entfernen'}
    />
);
